import { render, staticRenderFns } from "./ClientEditor.vue?vue&type=template&id=72d7cb3e&scoped=true&"
import script from "./ClientEditor.vue?vue&type=script&lang=js&"
export * from "./ClientEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d7cb3e",
  null
  
)

export default component.exports